import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgLatestFirst = (props) => (
  <SvgIcon {...props} title="LatestFirst">
    <svg
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.333 10h3.334a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834H1.333a.836.836 0 0 0-.833.834c0 .458.375.833.833.833ZM.5.833c0 .459.375.834.833.834h13.334A.836.836 0 0 0 15.5.833.836.836 0 0 0 14.667 0H1.333A.836.836 0 0 0 .5.833Zm.833 5h8.334A.836.836 0 0 0 10.5 5a.836.836 0 0 0-.833-.833H1.333A.836.836 0 0 0 .5 5c0 .458.375.833.833.833Z"
        fill={props.fill}
      />
    </svg>
  </SvgIcon>
);

export default SvgLatestFirst;
